<template>
  <div>
    <h1>Editar Tipo de Instituição</h1>
    <b-card>
      <Form @saved="loadData" />
    </b-card>
  </div>
</template>

<script>
import Form from "../Components/Form.vue";
import { mapState, mapActions } from "vuex";

export default {
  components: { Form },
  computed: {
    ...mapState("tipos_instituicoes", ["tipo_instituicao"]),
  },
  methods: {
    ...mapActions("tipos_instituicoes", [
      "ActionNewTipo_instituicao",
      "ActionShow",
    ]),
    async loadData(id) {
      try {
        await this.ActionShow(id);
      } catch (error) {
        this.$notifications.addNotification({
          message: error.data.responseMessage,
          icon: "exclamation-triangle",
          type: "danger",
        });
        this.$router.push({ name: "tipos_instituicoes_list" });
      }
    },
  },
  async created() {
    this.ActionNewTipo_instituicao();
    await this.loadData(this.$route.params.id);
  },
};
</script>

<style></style>
